import script from "./BasePhoto.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePhoto.vue?vue&type=script&setup=true&lang=js"

import "./BasePhoto.vue?vue&type=style&index=0&id=4338bf8e&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4338bf8e"]])

export default __exports__